import {useCallback, useRef} from "react";

/**
 * Returns a stable-identity wrapper around a callback that always invokes
 * the latest version. Useful when a callback is a dependency of `useMemo`
 * or `useCallback` but its identity changes on every render (e.g. inline
 * arrow, `useTranslation`'s `t`, or a prop drilled from a parent).
 *
 * Equivalent to the proposed React `useEvent` RFC.
 */
export function useStableCallback<T extends (...args: any[]) => any>(fn: T): T {
   const ref = useRef(fn);
   ref.current = fn;
   return useCallback((...args: any[]) => ref.current(...args), []) as T;
}
